export async function compress(
  data: string,
  opts?: {encoding?: CompressionFormat}
): Promise<string> {
  const arrayBuffer = stringToArrayBuffer(data);
  const compressedArrayBuffer = await compressArrayBuffer(arrayBuffer, opts?.encoding ?? 'gzip');
  const gzip = arrayBufferToBase64String(compressedArrayBuffer);
  return gzip;
}

export async function decompress(
  gzip: string,
  opts?: {encoding?: CompressionFormat}
): Promise<string> {
  const compressedArrayBuffer = base64StringToArrayBuffer(gzip);
  const decompressedArrayBuffer = await decompressArrayBuffer(
    compressedArrayBuffer,
    opts?.encoding ?? 'gzip'
  );
  const data = arrayBufferToString(decompressedArrayBuffer);
  return data;
}

//
// UTILS
//

// String <-> ArrayBuffer

function stringToArrayBuffer(string: string): ArrayBuffer {
  const bytes = new Uint8Array(string.length);
  for (let i = 0; i < string.length; i++) {
    bytes[i] = string.charCodeAt(i);
  }
  const arrayBuffer = bytes.buffer;
  return arrayBuffer;
}

function arrayBufferToString(arrayBuffer: ArrayBuffer): string {
  let string = '';
  const bytes = new Uint8Array(arrayBuffer);
  for (const byte of bytes) {
    string += String.fromCharCode(byte);
  }
  return string;
}

// Base64 string <-> ArrayBuffer

function base64StringToArrayBuffer(base64: string): ArrayBuffer {
  const binary = window.atob(base64);
  const arrayBuffer = stringToArrayBuffer(binary);
  return arrayBuffer;
}

function arrayBufferToBase64String(arrayBuffer: ArrayBuffer): string {
  const binary = arrayBufferToString(arrayBuffer);
  const base64 = window.btoa(binary);
  return base64;
}

// ArrayBuffer <-> GZIP ArrayBuffer

async function compressArrayBuffer(
  dataToCompress: ArrayBuffer,
  encoding: CompressionFormat
): Promise<ArrayBuffer> {
  const cs = new CompressionStream(encoding);
  const writer = cs.writable.getWriter();
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  writer.write(dataToCompress);
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  writer.close();
  const arrayBuffer = await new Response(cs.readable).arrayBuffer();
  return arrayBuffer;
}

async function decompressArrayBuffer(
  compressedData: ArrayBuffer,
  encoding: CompressionFormat
): Promise<ArrayBuffer> {
  const cs = new DecompressionStream(encoding);
  const writer = cs.writable.getWriter();
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  writer.write(compressedData);
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  writer.close();
  const arrayBuffer = await new Response(cs.readable).arrayBuffer();
  return arrayBuffer;
}
